import { Injectable } from '@angular/core';
import { Geolocation } from '@capacitor/geolocation';
import { Capacitor } from '@capacitor/core';
@Injectable({ providedIn: 'root' })
export class GlocationService {

  constructor() { }

  async getLocation() {
    return new Promise<string[]>(async (resolve, reject) => {
      if (Capacitor.platform === 'web') {
        if (navigator.geolocation) {
          if (!navigator.geolocation) {
            let res: any = this.Return_format(0,0, 2);
            resolve(res); return;//not support
          }else{
            navigator.geolocation.getCurrentPosition(async (position: any) => {
              if (position) {
                let _coords: any = position.coords;
                let res: any = this.Return_format(_coords.latitude, _coords.longitude, 1);
                resolve(res); return;
              }
            }, async (error) => { // User denied Geolocation
                // if (error.code == 1) {
                //   let res: any = this.Return_format(0,0, 2);
                //   resolve(res); return;
                // }
                let res: any = this.Return_format(0,0, 2);
                resolve(res); return;
              }
            )
          }
        
        }
      } else
      {
        try{
        
              var requestPermissions = await Geolocation.requestPermissions();
              if (requestPermissions.location && requestPermissions.location == "granted") {
                const coordinates: any = await Geolocation.getCurrentPosition({enableHighAccuracy: true,timeout : 5000})
                let res: any = this.Return_format(coordinates.coords.latitude, coordinates.coords.longitude, 1);
                resolve(res);return;
              }else{
                let res: any = this.Return_format(0,0, 2);
                resolve(res); return;
              }
        }
        catch (error) {
          console.log('catch error');
           //let res: any = this.Return_format(0,0, 2);
           let res: any = this.Return_format(undefined,undefined, 1);
          resolve(res); return;
        }


      }

    });
  }


  Return_format(lat: any, long: any, status: any) {
    return { status: status, lat: lat, long: long };
  }

  // async web_geo_permmission_check() {
  //   Common.log("permissionStatus1")
  //   const permissionStatus = await navigator?.permissions?.query({ name: 'geolocation' })
  //   Common.log("permissionStatus", permissionStatus)
  //   const hasPermission = permissionStatus?.state;
  //   return hasPermission;
  // }

}
